import { TicketsPage } from '@pages/Admin/ErrorTickets/pages/TicketsPage';

export const SupportCriticalTickets = () => {
  return <TicketsPage ticketType={1} />;
};
